import { FC } from 'react';
import RatingStars from './rating-stars/RatingStars';
import DraftSticker from '../draft-sticker/DraftSticker';
import VersionSticker from '../version-sticker/VersionSticker';
import RetellingSticker from '../retelling-sticker/RetellingSticker';
import SocialsBar from '../socials-bar/SocialsBar';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { IBookDetailData } from '@/interfaces/bookDetail.interface';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IBookPageForms } from '@/interfaces/bookPageForms';
import { hideImgOnError } from '@/helpers/helpers';
import styles from './BookInfoImg.module.scss';

const BookInfoImg: FC<IBookDetailData | any> = ({ book, formRef, setIsFormsActive, isPodcast }) => {
  const handleReviewFormActive = () => {
    setIsFormsActive((prevState: IBookPageForms) => ({ ...prevState, reviewFrom: true }));
  };

  const currentUrl = useGetUrlPath();

  const isPodcastList = !!currentUrl.includes('/podcasts/') && !isPodcast ? true : false;

  const isReviewButtonVisible = currentUrl.includes('/read/') || currentUrl.includes('/download/') ? false : true;

  const { rating } = book;
  const { title, external_id } = isPodcastList ? book : isPodcast ? book.podcast_item : book.book;

  return (
    <div className={styles.bookInfo__image} itemType="http://schema.org/Book">
      <div className={styles.bookInfo__cover}>
        <img src={`${DEV_ABSOLUTE_URL}/covers/${external_id}.jpg`} width="220" height="312" alt={`Скачать книгу ${title}`} onError={hideImgOnError} />

        <span className={isPodcastList || isPodcast ? `${styles.bookInfo__imageTxt} ${styles.bookInfo__imageTxt_podcast}` : `${styles.bookInfo__imageTxt}`}>
          {isPodcastList || isPodcast ? 'Подкаст' : `${book.type === 'audio_book' ? 'Аудио' : 'Текст'}`}
        </span>
        {!isPodcastList && !isPodcast && book.book.allow_full_free > 0 && book.book.type !== 'pdf' && <VersionSticker />}

        {book.draft && <DraftSticker />}
        {book.retelling_text && <RetellingSticker />}

      </div>
      {/* временно убрать на подкастах */}
      {!isPodcast && !isPodcastList && (
        <>

          <RatingStars rating={rating} id={book.id} formRef={formRef} isPodcastList={isPodcastList} isPodcast={isPodcast} setIsFormsActive={setIsFormsActive} />

          {isReviewButtonVisible && (
            <>
              {' '}
              <div className={styles.bookInfo__reviewsBtns}>
                <a href="#reviewForm" className={`${styles.bookInfo__reviewsBtn}`} onClick={handleReviewFormActive}>
                  Добавить отзыв
                </a>
              </div>
            </>
          )}
        </>
      )}
      <SocialsBar bookLink={!!isPodcastList ? `/podcasts/${book.alias}/` : !!isPodcast ? `/podcasts/${book.alias}/${book.podcast_item.id}/` : `/avtor/${book.author.alias}/${book.alias}/`} />
    </div>
  );
};

export default BookInfoImg;
